import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy, ChangeDetectorRef,
  Compiler, Component, ComponentFactory, ComponentRef, ModuleWithComponentFactories, NgModule, OnInit, ViewChild, ViewContainerRef
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { SafeHtmlPipe } from 'src/app/pipe/safe.pipe';
import { LazyLoadScriptService } from '../../lazy_load_script_service';
import { PageService } from '../../services';
import { Meta, Title } from '@angular/platform-browser';

declare function OneHr();
@Component({
  selector: 'app-training',
  templateUrl: './training.component.html',
  styleUrls: ['./training.component.scss']
})

// @NgModule({
//   imports: [
//     CommonModule
//   ]
//   declaration:
// })
export class trainingComponent implements OnInit {

  @ViewChild('container', { static: true, read: ViewContainerRef }) container: ViewContainerRef;

  private componentRef: ComponentRef<{}>;
  constructor(
    private service: PageService,
    public sanitizer: DomSanitizer,
    private compiler: Compiler,
    public cdRef: ChangeDetectorRef,
    private meta: Meta,
    private title: Title,
    private lazyLoadService: LazyLoadScriptService
  ) { 
    this.meta.addTags([
      {name: 'description', content: 'Training page of UN - One HR - Salary Survey'},
      {name: 'author', content: 'One HR, Salary Survey'},
      {name: 'keyword', content: 'One HR, Salary Survey, Training'}
    ]);
    this.setTitle('UN - Training');
  }
  public setTitle(newTitle: string){
    this.title.setTitle(newTitle); 
  }
  slug = 'training';
  trainingList;
  trainingDocList;
  totalItems = 10;
  currentPage = 1;
  itemPerPage = 10;
  pageVars: any = { sortByTitle: 'Type Ascending', itemPerPage: 10 };


  template: string;
  public ngOnInit() {
    this.service.get(this.slug).subscribe((response: any) => {
      var str = response.data.html?.map(ele => ele.html).join("");
      this.template = str;

      // this.template = `
      // <div class="sub-banner-new">
      //   <div class="align-centr-heading">
      //     <h1 class="heading-1 white biger" style="width:80%">
      //       Training
      //     </h1>
      //   </div>
      // </div>

      // <div class="section pb-2 mb-5">
      //   <div class="container-fluid">
      //     <div class="row">
      //       <div class="col-md-12">
      //         <p>
      //           An on-line training tool is in development. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam
      //           erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.
      //         </p>
      //       </div>
      //     </div>
      //   </div>
      // </div>

      // `;
      this.compileTemplate();
    });
      this.fetchTrainingandDocs();
  }
  

  compileTemplate() {
    let metadata = {
      selector: `runtime-component-sample`,
      template: this.template,
      changeDetection: ChangeDetectionStrategy.OnPush
    };

    let factory = this.createComponentFactorySync(this.compiler, metadata, null, this);

    if (this.componentRef) {
      this.componentRef.destroy();
      this.componentRef = null;
    }
    this.componentRef = this.container.createComponent(factory);
    this.lazyLoadService.loadScript('/assets/js/onehr.js').subscribe(_ => {

    });
  }


  private createComponentFactorySync(compiler: Compiler, metadata: Component, componentClass: any, THIS: any,): ComponentFactory<any> {
    const cmpClass = componentClass || class RuntimeComponent {
     
      public ngOnInit() {
        //this.fetchSPMs();
      }
      // fetchSPMs() {
      //   THIS.service.getSpecialMeasuresList(this.currentPage - 1 , this.pageVars.itemPerPage, this.pageVars.sortBy, this.pageVars.sortDirection).subscribe(res => {
      //     this.spm = res.data.result;
      //     this.totalItems = res.data.total;
      //   });
      // }
    
      

    };
    const decoratedCmp = Component(metadata)(cmpClass);

    const decoratedNgModule = NgModule({ imports: [CommonModule], declarations: [decoratedCmp] })(cmpClass);

    const module: ModuleWithComponentFactories<any> = compiler.compileModuleAndAllComponentsSync(decoratedNgModule);
    return module.componentFactories.find(f => f.componentType === decoratedCmp);
  }

  fetchTrainingandDocs(){
    this.service.getTrainingList(this.slug,this.currentPage - 1 , this.pageVars.itemPerPage, this.pageVars.sortBy, this.pageVars.sortDirection).subscribe((response: any) => {
     // console.log('response.data',this.currentPage - 1 , this.pageVars.itemPerPage, this.pageVars.sortBy, this.pageVars.sortDirection);
      if (response.data) {
        this.trainingList = response.data.result;
        this.totalItems = response.data.total;
        //this.resourcesList = response.data.resourcesId;
      }
      this.service.getTrainingDocsList(this.slug).subscribe((response: any) => {
       console.log('response.data',response.data);
        if (response.data) {
          this.trainingDocList = response.data;
          //this.resourcesList = response.data.resourcesId;
        }
        //console.log('trainingList',this.trainingList,response.data,this.trainingDocList);
      });
    
    });

  }
  
  sortTraining(attr, descending) {
    this.pageVars.sortBy = attr;
    this.pageVars.sortDirection = descending;
    this.fetchTrainingandDocs();
  }

  pageChanged(event) {
    // itemsPerPage: 2
    this.currentPage = event.page;
    // console.log(event);
    this.fetchTrainingandDocs();
  }
  
}
